import { AiEvent, AiEventType, ToolUseEvent } from "../../types/ai-event";

export type EventRow = { kind: "event"; key: string; event: AiEvent; index: number; showAvatar: boolean };
export type ToolGroupRow = {
  kind: "toolGroup";
  key: string;
  calls: Array<{ event: ToolUseEvent; index: number }>;
  showAvatar: boolean;
};
export type Row = EventRow | ToolGroupRow;

// Consecutive tool calls fold into one row so a run of them reads as "N tool calls" (spec D3). The key is the first call's key, so it
// stays stable while later calls join the run.
export function groupToolRows(rows: EventRow[]): Row[] {
  const out: Row[] = [];
  for (const row of rows) {
    if (row.event.type !== AiEventType.TOOL_USE) {
      out.push(row);
      continue;
    }
    const call = { event: row.event as ToolUseEvent, index: row.index };
    const last = out[out.length - 1];
    if (last && last.kind === "toolGroup") {
      last.calls.push(call);
    } else {
      out.push({ kind: "toolGroup", key: `toolgroup:${row.key}`, calls: [call], showAvatar: false });
    }
  }
  return out;
}
